/* client/src/dnd/components/pixi_parts/assetOverlay.js */
import React, { useEffect, useState } from "react";
import { ImageOverlay } from "react-leaflet";
import L from "leaflet";

function parseHidableFromDescription(asset) {
  if (!asset) return false;
  const desc = asset.description || asset.asset_description || "";
  if (!desc || typeof desc !== "string") return false;
  try {
    const parsed = JSON.parse(desc);
    return parsed?.hidable === true;
  } catch {
    return false;
  }
}

function isAssetHidable(asset) {
  if (!asset) return false;
  if (
    asset.hidable === true ||
    asset.hidable === 1 ||
    asset.hidable === "1"
  ) {
    return true;
  }
  return parseHidableFromDescription(asset);
}

export default function AssetOverlay({
  imageAssets = [],
  imageSize,
  editingAssetId = null,
  hiddenAssetIds = [],
  onHideAsset,
}) {
  const [secretsRevealed, setSecretsRevealed] = useState(false);

  useEffect(() => {
    function handleRevealSecrets() {
      setSecretsRevealed((prev) => !prev);
    }
    if (typeof window !== "undefined") {
      window.addEventListener(
        "pointatlas-demo-reveal-secrets",
        handleRevealSecrets
      );
      return () =>
        window.removeEventListener(
          "pointatlas-demo-reveal-secrets",
          handleRevealSecrets
        );
    }
  }, []);

  if (!Array.isArray(imageAssets) || !imageSize) return null;

  const mapW = Array.isArray(imageSize) ? Number(imageSize[0]) || 0 : 0;
  const mapH = Array.isArray(imageSize) ? Number(imageSize[1]) || 0 : 0;

  const isHiddenById = (id) =>
    Array.isArray(hiddenAssetIds) && hiddenAssetIds.includes(id);

  return (
    <>
      {imageAssets.map((a) => {
        if (!a || a.visible === 0) return null;
        if (!a.url) return null;
        if (editingAssetId && a.id === editingAssetId) return null;

        const hidable = isAssetHidable(a);
        if (isHiddenById(a.id)) return null;
        if (hidable && secretsRevealed) return null;

        const ax = Number.isFinite(a.anchor_x) ? a.anchor_x : 0.5;
        const ay = Number.isFinite(a.anchor_y) ? a.anchor_y : 0.5;
        const w = Number(a.placement_width) || 256;
        const h = Number(a.placement_height) || 256;

        const cx = Number.isFinite(a.placement_x) ? a.placement_x : mapW / 2;
        const cy = Number.isFinite(a.placement_y) ? a.placement_y : mapH / 2;

        const x0 = cx - w * ax;
        const y0 = cy - h * ay;
        const x1 = x0 + w;
        const y1 = y0 + h;

        const bounds = L.latLngBounds([y0, x0], [y1, x1]);

        const opacity = Number(a.opacity);
        const finalOpacity = Number.isFinite(opacity) ? opacity : 1;

        let url = String(a.url || "");
        if (
          !(
            url.startsWith("http://") ||
            url.startsWith("https://") ||
            url.startsWith("data:")
          )
        ) {
          const origin =
            typeof window !== "undefined" ? window.location.origin : "";
          url = origin + (url.startsWith("/") ? url : "/" + url);
        }

        const z = Number.isFinite(a.z_index) ? a.z_index : 400;

        return (
          <ImageOverlay
            key={a.id}
            url={url}
            bounds={bounds}
            pane="assets-pane"
            opacity={finalOpacity}
            zIndex={z}
            interactive={false}
            className="vtt-asset-image"
          />
        );
      })}
    </>
  );
}
